import React from 'react';
import { useAuth } from '../context/AuthContext';
import Navbar from './Navbar';
import ManagerNavbar from './ManagerNavbar';

const AppLayout = ({ children }) => {
  const { user } = useAuth();

  // For Managers, use the specialized ManagerNavbar
  if (user?.role === 'manager') {
    return <ManagerNavbar>{children}</ManagerNavbar>;
  }

  // Default Navbar for Testers, Developers, and others
  return <Navbar>{children}</Navbar>;
};

export default AppLayout;
